<template>
    <div ref="orderDetailsDialog">
        <app-dialog :title="$t('orderDetails.title')" :isOrderDetails="true" :width="getDialogWidth" max-width="95vw" :height="getDialogHeight" v-bind="{ ...$attrs }" @input="onDialogInput">
            <template v-slot:content>
                <div class="px-12 pb-6" v-if="!isMobile">
                    <div class="d-flex justify-space-between" ref="orderDetailsDialogHeader">
                        <div class="d-flex flex-column">
                            <div class="pb-3" v-if="userStore.hasPermissionTo('View client and branch number')">
                                <div class="pb-1">
                                    <span class="order-detail-title dark-blue-color"> {{ $t('orderDetails.clientNumber') }} </span>
                                </div>

                                <div v-if="selectedOrder.branch">
                                    <span class="order-detail-text grey-color"> {{ selectedOrder.branch.id }} </span>
                                </div>
                                <div v-else class="details-filler-div"></div>
                            </div>
                            <div v-else class="pb-3">
                                <div class="pb-1 details-filler-div"></div>
                                <div class="details-filler-div"></div>
                            </div>
                            <div class="pb-3">
                                <div class="pb-1">
                                    <span class="order-detail-title dark-blue-color"> {{ $t('orderDetails.documentNumber') }} </span>
                                </div>

                                <div v-if="selectedOrder.document_id">
                                    <span class="order-detail-text grey-color">
                                        {{ selectedOrder.document_id }}
                                    </span>
                                </div>
                                <div v-else class="details-filler-div"></div>
                            </div>

                            <div>
                                <div class="pb-1">
                                    <span class="order-detail-title dark-blue-color"> {{ $t('orderDetails.myprovetOrderNumber') }} </span>
                                </div>

                                <div>
                                    <span class="order-detail-text grey-color">
                                        {{ selectedOrder.id }}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <v-divider vertical />

                        <div class="d-flex flex-column">
                            <div class="pb-3">
                                <div class="pb-1">
                                    <span class="order-detail-title dark-blue-color"> {{ $t('orderDetails.clientName') }} </span>
                                </div>

                                <div v-if="selectedOrder.branch && selectedOrder.branch.name">
                                    <span class="order-detail-text grey-color">
                                        {{ selectedOrder.branch.name }}
                                    </span>
                                </div>
                                <div v-else class="details-filler-div"></div>
                            </div>

                            <div class="pb-3" style="height: 60px">
                                <div class="pb-1">
                                    <span class="order-detail-title dark-blue-color"> {{ $t('orderDetails.generatedInvoice') }} </span>
                                </div>
                                <div v-if="selectedOrder && selectedOrder.invoice_number">
                                    <span v-if="invoiceNumbers.length <= 1" class="order-detail-text grey-color">
                                        {{ selectedOrder.invoice_number }}
                                    </span>

                                    <v-select v-else :items="invoiceNumbers" :value="invoiceNumbers[0]" single-line dense hide-details style="max-width: 240px !important; margin-top: -8px !important"> </v-select>
                                </div>
                                <div v-else class="details-filler-div"></div>
                            </div>

                            <div>
                                <div class="pb-1">
                                    <span class="order-detail-title dark-blue-color"> {{ $t('orderDetails.documentDate') }} </span>
                                </div>

                                <div v-if="selectedOrder.created_at">
                                    <span class="order-detail-text grey-color">
                                        {{ formatDate(selectedOrder.created_at) }}
                                    </span>
                                </div>
                                <div v-else class="details-filler-div"></div>
                            </div>
                        </div>

                        <v-divider vertical />

                        <div class="d-flex flex-column">
                            <div class="pb-3">
                                <div class="pb-1">
                                    <span class="order-detail-title dark-blue-color"> {{ $t('orderDetails.trackingNumber') }} </span>
                                </div>

                                <div v-if="selectedOrder.tracking_number">
                                    <span class="order-detail-text grey-color">
                                        {{ selectedOrder.tracking_number }}
                                    </span>
                                </div>
                                <div v-else class="details-filler-div" style="min-width: 300px"></div>
                            </div>

                            <div class="pb-3">
                                <div class="pb-1">
                                    <span class="order-detail-title dark-blue-color"> {{ $t('orderDetails.approvedBy') }} </span>
                                </div>

                                <div v-if="user">
                                    <span class="order-detail-text grey-color">
                                        {{ user }}
                                    </span>
                                </div>
                                <div v-else class="details-filler-div"></div>
                            </div>

                            <div class="d-flex justify-space-between">
                                <div v-if="userStore.hasPermissionTo('View prices')">
                                    <div class="pb-1">
                                        <span class="order-detail-title dark-blue-color"> {{ $t('orderDetails.total') }} </span>
                                    </div>

                                    <div>
                                        <span class="order-detail-text grey-color">{{ formatPrice(selectedOrder.total_net_value) }}</span>
                                    </div>
                                </div>

                                <div>
                                    <div class="pb-1">
                                        <span class="order-detail-title dark-blue-color"> {{ $t('orderDetails.status') }} </span>
                                    </div>

                                    <div v-if="isPendingOrder || selectedOrder.status">
                                        <span v-if="isPendingOrder" class="order-detail-text red--text">{{ tb('EM PROCESSAMENTO') }}</span>

                                        <span v-else class="order-detail-text" :style="selectedOrder.status == 'PROCESSADO' ? 'color: green;' : 'color: red;'">
                                            {{ tb(selectedOrder.status) }}
                                        </span>
                                    </div>
                                    <div v-else class="details-filler-div"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <v-row v-else>
                            <v-col class="d-flex flex-column col pt-0 pb-0">
                                            <v-row class="d-flex align-start pt-0 pb-0">
                                                <v-col class="col col-4 px-0 pt-0 pb-0 wrap-l">
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field">{{ $t('table.status') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field">{{ $t('orderDetails.upper.clientNumber') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" v-if="isExpanded">{{ $t('orderDetails.upper.clientName') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" v-if="isExpanded">{{ $t('orderDetails.upper.documentDate') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" v-if="isExpanded">{{ $t('orderDetails.upper.myprovetOrderNumber') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" >{{ $t('orderDetails.upper.documentNumber') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" v-if="isExpanded">{{ $t('orderDetails.upper.approvedBy') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field invoices" v-if="isExpanded">{{ $t('table.generatedInvoices') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field" v-if="userStore.hasPermissionTo('View prices')" >{{ $t('table.total') }}</v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field invoices" v-if="isExpanded">{{ $t('table.trackingNumber') }}</v-col>
                                                </v-col>
                                                <v-col class="col col-8  pt-0 pb-0 wrap-r">
                                                    <v-col class="col col-12 px-0 pt-0 pb-0">
                                                        <v-col class="d-flex px-0 mx-0 pt-0 pb-0 flex-column">
                                                            <v-col class="d-flex align-start px-0 pt-0 pb-0">
                                                                <v-col class="col col-12 px-0 pt-0 pb-0 field-r ">
                                                                    <div v-if="isPendingOrder || selectedOrder.status">
                                                                            <span v-if="isPendingOrder" class="order-detail-text red--text">{{ tb('EM PROCESSAMENTO') }}</span>

                                                                            <span v-else class="order-detail-text" :style="selectedOrder.status == 'PROCESSADO' ? 'color: green;' : 'color: red;'">
                                                                                {{ tb(selectedOrder.status) }}
                                                                            </span>
                                                                        </div>
                                                                    <!--<span style="cursor: pointer" :style="selectedOrder.status === 'PROCESSADO' ? 'color: green' : 'color: red'">{{selectedOrder.status }}</span>-->
                                                                </v-col>
                                                               <!-- <v-col class="col col-1 px-0 pt-0 pb-0">
                                                                    <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-1" style="cursor: pointer" @click="toggleOrderDetails" v-if="!isExpanded"> mdi-chevron-down </v-icon>
                                                                    <v-icon  v-else small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-1" style="cursor: pointer" @click="toggleOrderDetails"> mdi-chevron-up </v-icon>
                                                                </v-col>-->
                                                            </v-col>
                                                        </v-col>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                        <div class="datatable-designation-text" style="cursor: pointer">
                                                            {{ selectedOrder.branch.id }}
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" v-if="isExpanded">
                                                        <div class="datatable-designation-text" style="cursor: pointer">
                                                            {{ selectedOrder.branch.name }}
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" v-if="isExpanded">
                                                        <div class="datatable-designation-text" style="cursor: pointer">
                                                            {{ selectedOrder.created_at | moment }}
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" v-if="isExpanded">
                                                        <div class="datatable-designation-text" style="cursor: pointer">
                                                            {{ selectedOrder.id }}
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r">
                                                        <div class="datatable-designation-text" style="cursor: pointer">
                                                            {{ selectedOrder.document_id }}
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" v-if="isExpanded">
                                                        <div class="datatable-designation-text" style="cursor: pointer" v-if="selectedOrder.user!=null">
                                                            {{ selectedOrder.user }}
                                                        </div>
                                                        <div v-else class="empty">
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" v-if="isExpanded">
                                                        <div class="datatable-designation-text" style="cursor: pointer" >

                                                            <div v-if="selectedOrder && selectedOrder.invoice_number">
                                                                <span v-if="invoiceNumbers.length <= 1">
                                                                    {{ selectedOrder.invoice_number }}
                                                                </span>

                                                                <v-select v-else :items="invoiceNumbers" :value="invoiceNumbers[0]" single-line dense hide-details style="max-width: 240px !important; margin-top: -8px !important"> </v-select>
                                                            </div>
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" v-if="userStore.hasPermissionTo('View prices')">
                                                        <div class="datatable-designation-text" style="cursor: pointer" >
                                                            {{ formatPrice(selectedOrder.total_net_value) }}
                                                        </div>
                                                    </v-col>
                                                    <v-col class="col col-12 px-0 pt-0 pb-0 field-r" v-if="isExpanded">
                                                        <div class="datatable-designation-text" style="cursor: pointer" v-if="selectedOrder.tracking_number!=null">
                                                            {{ selectedOrder.tracking_number}}
                                                        </div>
                                                        <div v-else class="empty">
                                                        </div>
                                                    </v-col>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                 </v-row>
                <pure-datatable :endpoint="endpoint" :queryParams="queryParams" :ready="ready" @data-changed="dataChanged" ref="datatableDetails" v-slot:default="{ vOn, vBind, updateOptions, isLoading }">
                    <div>
                        <v-data-table
                            class="elevation-1 mt-2 d-flex flex-column justify-space-between no-extra-padding-data-table nowrap-headers"
                            :style="`border-radius: 16px; height: ${datatableSize}px;`"
                            fixed-header
                            multi-sort
                            :headers="tHeaders(detailsHeaders)"
                            :headerProps="headerProps"
                            @update:options="updateOptions"
                            v-on="vOn"
                            v-bind="vBind"
                            hide-default-footer
                            :no-data-text="$t('table.noData')"
                            :no-results-text="$t('table.noResults')"
                            :loading="isMobile?isLoading:false"
                            :loading-text="$t('table.loading')"
                            :item-class="isLinePendingOrDeleted"
                            :footer-props="{
                                showFirstLastPage: false,
                                itemsPerPageOptions:itemsPerPageOptions,
                                itemsPerPageText: $t('table.itemsPerPage'),
                            }"
                        >
                            <template v-if="!isMobile" #[`header.campaign`]>
                                <v-icon style="right: 10%">mdi-star-outline</v-icon>
                            </template>

                            <template v-if="!isMobile" #[`item.code`]="scope">
                                <div style="cursor: default">
                                    {{ scope.item.code }}
                                </div>
                            </template>

                            <template v-if="!isMobile" #[`item.designation`]="scope">
                                <div class="datatable-designation-text" style="cursor: default">
                                    {{ scope.item.designation }}
                                </div>
                            </template>

                            <template v-if="!isMobile" #[`item.quantity`]="scope">
                                <div v-if="scope.item.discounted_price != 0" style="cursor: default">{{ scope.item.quantity }}</div>
                            </template>

                            <template v-if="!isMobile" #[`item.bonus`]="scope">
                                <div v-if="scope.item.discounted_price != 0 && (!scope.item.campaign_stamp || (scope.item.campaign_stamp && scope.item.discount1 == 0))" style="cursor: default"></div>
                                <div v-else-if="scope.item.campaign_stamp && scope.item.discount1 > 0 && scope.item.discount1 != 100" style="cursor: default">{{ formatDecimal(scope.item.discount1) }} %</div>
                                <div v-else>{{ scope.item.quantity }}</div>
                            </template>

                            <template v-if="!isMobile" #[`item.price`]="scope">
                                <div style="cursor: default">
                                    {{ formatPrice(scope.item.price) }}
                                </div>
                            </template>

                            <template v-if="!isMobile" #[`item.discounted_price`]="scope">
                                <div style="cursor: default">
                                    {{ formatPrice(scope.item.discounted_price) }}
                                </div>
                            </template>

                            <template v-if="!isMobile" #[`item.campaign`]="scope">
                                <template v-if="userStore.hasPermissionTo('View campaigns') && !branchNoCampaigns">
                                    <campaign-tooltip v-if="hasBonus(scope.item)" isOutlined :text="$t('orders.pending.campaignBonus')"></campaign-tooltip>
                                    <campaign-tooltip v-else-if="scope.item.campaign_stamp" disabled :text="scope.item.campaign_desc ? scope.item.campaign_desc : $t('orders.pending.campaign')"></campaign-tooltip>
                                </template>
                            </template>
                            <template v-if="isMobile" v-slot:item="{ item, index }">
                               <tr>
                                <v-card
                                    elevation="2"
                                    :class="isLinePendingOrDeleted(item)"
                                    >
                                    <v-row>
                                        <v-col class="d-flex flex-column col pt-0 pb-0">
                                            <v-row class="d-flex align-start pt-0 pb-0">
                                                <v-col  class="col col-3 pt-0 pb-0">
                                                    <product-image :productCode="item.invoice_code" :imageSrc="item.product?item.product.image:'/storage/assets/no-image.jpg'" :is-new="!!item.new" width="84" height="84" max-width="84" max-height="84" style="cursor: pointer; position: relative" @click="openProductDetails(item.product)"></product-image>
                                                </v-col>
                                                <v-col  class="col col-9 pt-0 pb-0">
                                                    <v-row class="d-flex align-start pt-0 pb-0">
                                                        <v-col class="col col-12 pt-0 pb-0">
                                                            <div class="pl-0 datatable-designation-text" style="cursor: pointer" @click="openProductDetails(item.product)">
                                                                {{ item.designation }}
                                                            </div>
                                                            <v-col  class="col col-12 mx-0 px-0 pt-0 pb-0">
                                                                <div class="pl-0 datatable-lable-text code">
                                                                    {{ item.code}}
                                                                </div>
                                                            </v-col>
                                                        </v-col>
                                                        <v-col class="col col-12 pt-0 pb-0 stock">
                                                            <template v-if="userStore.hasPermissionTo('View campaigns') && !branchNoCampaigns">
                                                                <campaign-tooltip v-if="hasBonus(item)" isOutlined :text="$t('orders.pending.campaignBonus')"></campaign-tooltip>
                                                                <campaign-tooltip v-else-if="item.campaign_stamp" disabled :text="item.campaign_desc ? item.campaign_desc : $t('orders.pending.campaign')"></campaign-tooltip>
                                                                <v-icon small class="appbar-icon-button-small btn-bg-color-blue dark-blue-color ml-1" style="cursor: pointer" @click="openProductDetails(item.product)" data-cy="product-details"> mdi-dots-horizontal-circle-outline </v-icon>
                                                            </template>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col  class="col col-12 pt-0 pb-0">
                                                    <v-divider></v-divider>
                                                 </v-col>
                                                 <v-col  class="col col-12 pt-0 pb-0">
                                                    <v-row class="d-flex align-start pt-0 pb-0">
                                                        <v-col class="col col-6 pt-2 pb-0 pl-0">
                                                            <div class="col pt-0 pb-0 label">{{ $t('orders.base.quantity') }}</div>
                                                            <div class="label c"  v-html="item.discounted_price!=0 ?item.quantity:'-'" style="cursor: default"></div>
                                                        </v-col>
                                                        <v-col class="col col-6 pt-2 pb-0 pl-0">
                                                            <div class="col pt-0 pb-2  pl-0 pr-0 label lf "><div class="l-sub">{{ $t('orderDetails.upper.grossUnitValue') }}</div><div class="l-sub-value"> {{ formatPrice(item.price) }}</div></div>

                                                        </v-col>
                                                    </v-row>
                                                 </v-col>
                                                 <v-col  class="col col-12 pt-0 pb-0">
                                                    <v-row class="d-flex align-start pt-0 pb-0">
                                                        <v-col class="col col-6 pt-2 pb-0 pl-0">
                                                            <div class="col pt-0 pb-0 label">{{ $t('orders.base.bonus') }}</div>
                                                            <div class="label c" v-if="item.discounted_price != 0 && (!item.campaign_stamp || (item.campaign_stamp && item.discount1 == 0))" v-html="'-'" style="cursor: default"></div>
                                                            <div class="label c" v-else-if="item.campaign_stamp && item.discount1 > 0 && item.discount1 != 100" style="cursor: default" v-html="formatDecimal(item.discount1)+' %'"  >{{ formatDecimal(item.discount1) }} %</div>
                                                            <div class="label c" v-else v-html="item.quantity==null?'-':item.quantity">{{ item.quantity }}</div>
                                                        </v-col>
                                                        <v-col class="col col-6 pt-2 pb-0 pl-0">
                                                            <div class="col pt-0 pb-2  pl-0 pr-0 label lf "><div class="l-sub">{{ $t('orderDetails.upper.netUnitValue') }}</div><div class="l-sub-value">
                                                                {{ formatPrice(item.discounted_price) }}
                                                            </div>
                                                           </div>

                                                        </v-col>
                                                    </v-row>
                                                 </v-col>

                                            </v-row>
                                        </v-col>
                                    </v-row>

                                </v-card>
                              </tr>
                            </template>
                            <template v-slot:footer="scope">
                                <div>
                                    <div class="datatable-footer-border"></div>

                                    <data-table-footer :showExport="canExport() && selectedOrder.id!=null && selectedOrder.id!=''" :scope="scope" @export="exportOrderDetails" @updateOptions="updateOptions" :showOrderButton="false" :isLoading="isLoading" style="height: fit-content"> </data-table-footer>
                                </div>
                            </template>
                        </v-data-table>
                    </div>
                </pure-datatable>
            </template>
        </app-dialog>
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useUserStore } from '@/Stores/user';
import { useBranchStore } from '@/Stores/branch';
import {useAppStore} from '@/Stores/app'
import PureDatatable from '@arentia/atools/PureDatatable';
import { axios } from '@/Services/Backend';
import ResizeObserver from 'resize-observer-polyfill';
import moment from 'moment';

export default {
    props: {
        selectedOrder: Object,
        detailsHeaders: [Object, Array],
        height: String,
        isPendingOrder: {
            type: Boolean,
            default: false,
        },
    },

    components: {
        PureDatatable,
    },
    filters: {
        moment: function (date) {
            return moment(date).format('YYYY-MM-DD');
        },
    },
    data() {
        return {
            /*products: [],
            expandedProducts: [],
            productCampaigns: [],
            originalProductCampaigns: [],
            manipulatedProductCampaigns: [],
            isDetailedCampaignDialogOpen: false,
            isProductDetailsDialogOpen: false,
            selectedProduct: {},
            currentSearchTerm:null,*/
            isPageLoading: false,
            isLoading: false,
            datatableSize: 200,
            resizeObserver: null,
            user: null,
            queryParams: {
                order_id: null,
                document_id: null,
            },
            ready: false,
            isExpanded:false,
            itemsPerPageOptions: window.innerWidth>=768&&window.innerWidth<=1366?[20,50,100]:[10,20,50]
        };
    },

    mounted() {
        if(!this.isMobile)
          this.prepareResponsiveBehaviour();
    },

    beforeDestroy() {
        this.resizeObserver?.unobserve(this.$refs.orderDetailsDialog);
        this.resizeObserver?.unobserve(this.$refs.orderDetailsDialogHeader);
    },

    watch: {
        'branchStore.branch': {
            handler: function (branch) {
                if (!branch) return;

                this.queryParams.branch_id = branch.id;
                this.queryParams.order_id = this.selectedOrder.id;
                this.queryParams.document_id = this.selectedOrder.document_id;

                this.ready = true;
                this.refresh();
            },
            immediate: true,
        },

        selectedOrder: {
            handler: function (order) {
                this.user = null;
                this.queryParams.order_id = order.id;
                this.queryParams.document_id = order.document_id;
                if (order.origin === 'MPV') this.getUser(order.document_id);
            },
            immediate: true,
        },
    },

    computed: {
        ...mapStores(useUserStore, useBranchStore,useAppStore),

        endpoint() {
            return '/api/orders/details';
        },

        invoiceNumbers() {
            return this.selectedOrder.invoice_number
                .split(';') //
                .filter((it) => it);
        },

        getDialogWidth() {
            return this.getResponsiveDialogWidth('95vw', '70vw');
        },

        getDialogHeight() {
            return this.getResponsiveDialogHeight('85vh', '85vh');
        },

        branchNoCampaigns() {
            return this.branchStore.hideCampaigns;
        },
        isMobile(){
            return this.appStore.is_mobile
        },
        headerProps(){
            return this.appStore.header_props
        }
    },

    methods: {
        isLinePendingOrDeleted(item) {
            if (item.pending_quantity) {
                return 'btn-bg-color-yellow';
            }

            if (item.deleted_line) {
                return 'btn-bg-color-light-red';
            }
        },

        getUser(document_id) {
            //if (this.userStore.hasPermissionTo('View product stocks')) {
                axios.get('/api/orders/details-user', { params: { document_id: document_id } }).then(({ data }) => {
                    this.user = data;
                });
            //}
        },

        dataChanged() {
            this.computeDatatableSize();
            const wrapper = this.$refs['datatableDetails']?.$el?.querySelector('div.v-data-table__wrapper');
            this.scrollDatatableToTop(this.$vuetify, wrapper);
        },

        prepareResponsiveBehaviour() {
            const makeResponsive = () => {
                this.computeDatatableSize();
            };

            this.resizeObserver = new ResizeObserver(makeResponsive);

            window.addEventListener('resize', makeResponsive);
            this.resizeObserver.observe(this.$refs.orderDetailsDialog);
            this.resizeObserver.observe(this.$refs.orderDetailsDialogHeader);

            makeResponsive();
        },

        computeDatatableSize() {
            this.$nextTick(() => {
                const topElement = this.$refs.orderDetailsDialogHeader;
                const dialogElement = document.querySelector('.order-details-dialog');
                if (topElement && dialogElement) {
                    const headerBottom = topElement.getBoundingClientRect().bottom;
                    const dialogBottom = dialogElement.getBoundingClientRect().bottom;
                    this.datatableSize = dialogBottom - headerBottom - 77;
                }
            });
        },

        canExport() {
            return this.userStore.hasPermissionTo('Export orders');
        },

        exportOrderDetails() {
            if (!this.branchStore.branch || !this.$refs.datatableDetails) return;

            if (!this.selectedOrder.document_id) return this.showError(this.$t('orderDetails.exportError'));

            const axiosSettings = {
                url: '/api/orders/history/details/export',
                params: {
                    branch_id: this.branchStore.branch.id,
                    order_id: this.selectedOrder.id,
                    document_id: this.selectedOrder.document_id,
                },
            };

            this.$refs.datatableDetails.exportData(axiosSettings, `export_encomenda_${this.selectedOrder.document_id}`);
        },

        onDialogInput(event) {
            if (!event) {
                this.$emit('onCancel', false);
            }
        },

        onCloseDialog() {
            this.$emit('onCancel', false);
        },

        refresh() {
            if (!this.branchStore.branch) return;

            if (this.$refs.datatableDetails) {
                if(this.$refs.datatable)
                    this.$refs.datatable.onChangeQueryBuilder({});
            }
        },

        hasBonus(branch_order_line) {
            return branch_order_line.campaign_originating_stamps && branch_order_line.discounted_price == 0;
        },
    },
};
</script>

<style scoped>
.order-detail-title {
    font-weight: bold;
}

.order-detail-text,
.order-detail-title {
    font-size: 0.9em;
}

.details-filler-div {
    height: 22px;
}
</style>
